import Modal from "src/components/common/modal";
import UserInfo from "src/components/common/userInfo";
import { MyDate, onlyUnique, objAscSort } from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export function StatusForm({
    closeIt,
    userList
}){
    const compareDate = (earlyDateStr, lateDateStr) => {
        const earlyDate = new MyDate(earlyDateStr);
        earlyDate.setMonth(earlyDate.getMonth() + 1);
        return earlyDate.s() < lateDateStr;
    }
    const data = userList.filter(form => form.formType === "Calibration Verification Form" && form.dateSubmitted);
    const submitterEmails = data.map(form => form.submitterEmail).filter(onlyUnique);
    return <Modal title = "Calibration Verification Status" closeIt = {closeIt} width = {1200}>
        <div className = "table-responsive">
        <table className = "table">
            <thead>
                <tr>
                    {submitterEmails.map((submitterEmail, submitterEmailIndex) => 
                    <th key = {submitterEmailIndex}>
                        <UserInfo
                            email = {submitterEmail}
                            name = {data.find(form => form.submitterEmail === submitterEmail).submitter}
                        />
                    </th>)}
                </tr>
            </thead>
            <tbody>
                <tr>
                    {submitterEmails.map((submitterEmail, submitterEmailIndex) => 
                    <th key = {submitterEmailIndex}>
                        {
                        data
                        .filter(form => form.submitterEmail === submitterEmail)
                        .map(form => JSON.parse(form.formContent || "{}"))
                        .sort((a, b) => objAscSort(a, b, "Date"))
                        .map((form, formIndex, forms) => 
                        <li
                            key = {formIndex}
                            className = {formIndex > 0 && compareDate(forms[formIndex - 1].Date, form.Date)?"text-danger":""}
                        >
                            {form.Date}
                        </li>)
                        }
                    </th>)}
                </tr>
            </tbody>
        </table>
        </div>
    </Modal>
}